import React from "react";
import { Link } from "../../../utils/customLink";
import Image from "../../image";

import Training from "./training";

const Qualifications = ({
  qualifications,
  programTrainingTitle,
  trainingIntroductionText,
  gviTrainingList,
  hubTrainings,
  hubName,
  programQualificationsContent
}) => {
  return (
    <>
      <Training
        programTrainingTitle={programTrainingTitle}
        trainingIntroductionText={trainingIntroductionText}
        gviTrainingList={gviTrainingList}
        hubTrainings={hubTrainings}
        hubName={hubName}
      />

      {qualifications && qualifications.length > 0 && (
        <>
          <div className="pt-6">
            <h2 className="heading text-left py-5">
              Certificates & qualifications
            </h2>
            <div
              className="text-black-lighter planet:text-gray-generic"
              dangerouslySetInnerHTML={{ __html: programQualificationsContent }}
            />
          </div>

          <div className="flex flex-col justify-between pt-5 text-black-lighter planet:gvi-light-gray-text text-sm">
            {qualifications?.map((item, idx) => (
              <div
                className="flex flex-col bg-gray-lighten planet:bg-gray-darker rounded-md py-5 mt-5 px-5"
                key={idx}
              >
                <div className="flex flex-col md:flex-row items-center justify-between py-5 border-b border-gray-light sm:border-b-0">
                  <div className="w-full sm:w-2/5 h-full border-0 sm:border-r border-gray-light sm:pr-10">
                    <Image
                      imageClass={"object-cover rounded-md"}
                      imageAlt={""}
                      image={
                        item?.featuredImage?.node?.localFile?.extension
                          ? item?.featuredImage?.node?.localFile
                          : null
                      }
                      sourceUrl={item?.featuredImage?.node?.sourceUrl}
                    />
                  </div>
                  <h3 className=" w-full sm:w-3/5 pt-10 pb-5 sm:pt-0 sm:pb-0 sm:pl-10 font-bold text-mob sm:text-base">
                    {item.title}
                  </h3>
                </div>
                <div className="bh-block-content py-5 tab-content_html">
                  <div
                    className="text-inherit"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </div>
              </div>
            ))}
          </div>

          <Link
            className="text-base font-bold underline text-white mt-6  hidden"
            to="#"
          >
            Read Free Time & Culture next
          </Link>
        </>
      )}
    </>
  );
};

export default Qualifications;
